<div class="accessCodeError">
  <p>{{'access-code.access_codes_conversion_error' | translate}}</p>
</div>
